import { Extension } from "@tiptap/core";

// Adds a `dir` attribute to every block type that can carry one, mirroring the old editor's
// HE/EN toolbar buttons and QuestionContentRenderer's AUTO_DIR_BLOCKS server-side injection —
// both already expect physical `dir="rtl"`/`dir="ltr"`/`dir="auto"` on these exact tag names.
export const Direction = Extension.create({
  name: "direction",

  addGlobalAttributes() {
    return [
      {
        types: ["paragraph", "heading", "blockquote", "listItem"],
        attributes: {
          dir: {
            default: null,
            parseHTML: (el: HTMLElement) => el.getAttribute("dir"),
            renderHTML: (attrs: { dir?: string | null }) =>
              attrs.dir ? { dir: attrs.dir } : {},
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setDirection:
        (dir: "rtl" | "ltr" | "auto") =>
        ({ commands }: any) => {
          const types = ["paragraph", "heading", "blockquote", "listItem"];
          return types.map((type) => commands.updateAttributes(type, { dir })).some(Boolean);
        },
    } as any;
  },
});
